import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SessionService } from 'src/app/session-service.service';
import { FormBuilder, FormGroup, Validators, } from '@angular/forms';
import { NOTIFICATION_TYPE, NotificationEvent, NotificationService } from 'src/app/services/NotificationService';
import { MatStepper } from '@angular/material/stepper';
import {StringTemplates, TemplateService} from '../../services/TemplateService';
import { ProductTypeEnum } from '../../model/enums/ProductTypeEnum';
import { ConfigSettingDto } from '../../model/business/ConfigSettingDto';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-application-summary',
  templateUrl: './application-summary.component.html',
  styleUrls: ['./application-summary.component.css'],
})
export class ApplicationSummaryComponent implements OnInit, OnDestroy {
  policyTerms: string;
  intermediaryName: string;
  productType = ProductTypeEnum.ORV;
  formGroup: FormGroup;

  notificationEvent: NotificationEvent;

  @Input()
  stepper: MatStepper;

  @Output()
  submitClicked = new EventEmitter();
  premiumSubscription: Subscription;
  notificationSubscription: Subscription;
  constructor(
    private sessionService: SessionService,
    private translateService: TranslateService,
    private fb: FormBuilder,
    private templateService: TemplateService,
    private notificationService: NotificationService,
  ) {}

  ngOnInit(): void {
    this.premiumSubscription = this.sessionService.getCalculationResponse.subscribe((premiums) => {
      this.policyTerms = premiums.policyTerms;
    });

    this.formGroup = this.fb.group({
      isAgreed: ['', Validators.requiredTrue],
    });
    this.listenToNotifications();
  }

  ngOnDestroy(): void {
    this.premiumSubscription.unsubscribe();
    this.notificationSubscription.unsubscribe();
  }

  parseTemplatedStatement(statement: string, template: StringTemplates | Array<StringTemplates>): string {
    return this.templateService.parseTemplatedStatement(statement, template, {
      policyTerms: this.policyTerms,
      intermediaryName: this.sessionService.intermediaryName,
      intermediaryFee: this.sessionService.intermediaryFee,
      intermediarySubscriptionFee: this.sessionService.intermediarySubscriptionFee,
    });
  }

  getTextFor8Paragraph(): string {
    if (this.sessionService.getConfigSettingsDto().showIntermediaryFee && this.sessionService.getConfigSettingsDto().showIntermediarySubscriptionFee) {
      return this.parseTemplatedStatement('ClosingStatement.Bullet8_withSubscriptionFee', ['name_intermediary', 'intermediary_subscription_fee']);
    }
    if (!this.sessionService.getConfigSettingsDto().showIntermediaryFee && this.sessionService.getConfigSettingsDto().showIntermediarySubscriptionFee) {
      return this.parseTemplatedStatement('ClosingStatement.Bullet8_withFee', ['name_intermediary', 'intermediary_fee']);
    }
    if (this.sessionService.getConfigSettingsDto().showIntermediaryFee && !this.sessionService.getConfigSettingsDto().showIntermediarySubscriptionFee) {
      return this.parseTemplatedStatement('ClosingStatement.Bullet8_withoutSubscriptionFee', ['name_intermediary']);
    }
    return '';
  }

  getTextForFinalStatementAddition (): string {
    return this.sessionService.getConfigSettingsDto().finalStatementAddition
  }

  get configSettings(): ConfigSettingDto {
    return this.sessionService.getConfigSettingsDto();
  }

  listenToNotifications(): void {
    this.notificationSubscription = this.notificationService.register().subscribe((event) => {
      this.notificationEvent = event;
    });
  }

  submitApplication(): void {
    this.notificationEvent = {
      type: NOTIFICATION_TYPE.HIDDEN,
    };

    if (this.formGroup.get('isAgreed').valid) {
      this.submitClicked.emit();
    } else {
      this.formGroup.get('isAgreed').markAsTouched();
      this.translateService.get('Common.ValidationFailedMessage').subscribe(message => {
        this.notificationEvent = {
          type: NOTIFICATION_TYPE.WARNING,
          messages: [message],
        };
      });
    }
  }
}
